var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlayDiv"},[_c('span',[_vm._v(_vm._s(_vm.getAddress))]),_c('br'),_vm._v(" "),_c('br'),_c('div',{staticClass:"business-hours",domProps:{"innerHTML":_vm._s(_vm.getBusinessHours)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }